import { useContext, useRef } from 'react';
import { useLocation } from 'react-router';

import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import CaretLeft from 'components/icons/navigation/CaretLeft';
import { BrandContext } from 'context/BrandContext';
import { getBrandRoute } from 'helpers/routes';
import useFunnelMealPlan from 'hooks/useFunnelMealPlan';
import useFunnelNavigation from 'hooks/useFunnelNavigation';
import { FAMILY } from 'lib/constants';

const BackButton = () => {
  const { brand } = useContext(BrandContext);
  const { previousStep } = useFunnelNavigation();
  const location = useLocation();
  const mealPlanSlug = useFunnelMealPlan();
  const isFamilyMealPlan = mealPlanSlug === FAMILY;
  const initialParamsRef = useRef(null);

  if (!initialParamsRef.current) {
    initialParamsRef.current = location.search;
  }
  const brandRoutes = getBrandRoute({ brand, isFamily: isFamilyMealPlan });
  const previousFunnelStep = previousStep;

  if (
    location.pathname.includes(brandRoutes.intro) ||
    location.pathname.includes(brandRoutes.thankyou) ||
    !previousFunnelStep
  ) {
    return <div className="hidden w-16 bp1:inline-block"></div>;
  }

  return (
    <div className="flex items-center">
      <DefaultLink
        to={previousFunnelStep.route + (initialParamsRef.current || '')}
        className="flex items-center pr-0 text-xs font-medium bp1:pl-5"
      >
        <CaretLeft className="h-4 w-4" />
        <Text
          htmlElement="span"
          className="sr-only uppercase bp1:not-sr-only"
          style={{ paddingLeft: '0.25rem' }}
        >
          Back
        </Text>
      </DefaultLink>
    </div>
  );
};

export default BackButton;
